import { useEffect, useState } from "react";
import { Shield, Mail, Trash2 } from "lucide-react";

// TypeScript Interface for User
interface User {
  id: number;
  name: string;
  email: string;
  role: string;
}

const UserList = () => {
  // useState me <User[]> lagaya hai error fix karne ke liye
  const [users, setUsers] = useState<User[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [message, setMessage] = useState({ text: "", type: "" });

   // NAYA FUNCTION: User delete karne ke liye
   // NAYA FUNCTION: Delete handle karne ke liye
  const handleDelete = async (userId: number) => {
    setMessage({ text: "", type: "" }); // purana message clear karo
    
    try {
      const token = localStorage.getItem("sevaa_admin_token");
      // const response = await fetch(`http://localhost:1415/api/auth/users/${userId}`, {
      // const response = await fetch(`http://localhost/seva-backend/api/auth/users.php?=${userId}`, {
      const response = await fetch(`https://www.sevaafoundation.com/seva-backend/api/auth/users.php?=${userId}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await response.json();
      
      if (data.success) {
        setMessage({ text: "User deleted successfully!", type: "success" });
        // Delete hone ke baad list se user hata do UI update karne ke liye
        setUsers(users.filter(user => user.id !== userId));
      } else {
        setMessage({ text: data.error || "Failed to delete user", type: "error" });
      }
    } catch (error) {
      setMessage({ text: "Network error occurred", type: "error" });
    }
    
    // 3 second baad message gayab karne ke liye (Optional par accha lagta hai)
    setTimeout(() => setMessage({ text: "", type: "" }), 3000);
  };

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem("sevaa_admin_token");
        // const response = await fetch("http://localhost:1415/api/auth/users", {
        // const response = await fetch("http://localhost/seva-backend/api/auth/users.php", {
        const response = await fetch("https://www.sevaafoundation.com/seva-backend/api/auth/users.php", {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await response.json();
        
        if (data.success) {
          setUsers(data.users);
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUsers();
  }, []);

  return (
    <div className="p-6 bg-slate-50 min-h-screen">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-2xl font-bold text-slate-900">User Management</h1>
          <p className="text-slate-500 text-sm">View and manage system access</p>
        </div>
      </div>

     <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
        
        {/* NAYA BLOCK: Message alert show karne ke liye */}
        {message.text && (
          <div className={`m-4 p-3 rounded-lg text-sm font-medium flex items-center gap-2 ${message.type === 'success' ? 'bg-emerald-50 text-emerald-700 border border-emerald-200' : 'bg-red-50 text-red-700 border border-red-200'}`}>
            {message.text}
          </div>
        )}

        {isLoading ? (
          <div className="p-8 text-center text-slate-500">Loading users...</div>
        ) : (
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-slate-50 border-b border-slate-200 text-slate-600 text-sm">
                <th className="p-4 font-semibold">Name</th>
                <th className="p-4 font-semibold">Email</th>
                <th className="p-4 font-semibold">Role</th>
                {/* NAYI LINE: Action header */}
                <th className="p-4 font-semibold text-center">Action</th> 
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.id} className="border-b border-slate-100 hover:bg-slate-50 transition-colors">
                  {/* ... (Name, Email, Role wale purane td same rahenge) ... */}
                  <td className="p-4 flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center text-slate-600 font-bold">
                      {user.name.charAt(0)}
                    </div>
                    <span className="font-medium text-slate-800">{user.name}</span>
                  </td>
                  <td className="p-4 text-slate-600">
                    <div className="flex items-center gap-2">
                      <Mail size={16} className="text-slate-400" />
                      {user.email}
                    </div>
                  </td>
                  <td className="p-4">
                    <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium ${
                      user.role === 'Superadmin' ? 'bg-purple-100 text-purple-700' : 'bg-blue-100 text-blue-700'
                    }`}>
                      <Shield size={14} />
                      {user.role}
                    </span>
                  </td>

                  {/* NAYA BLOCK: Delete Button td */}
                  <td className="p-4 text-center">
                    <button 
                      onClick={() => handleDelete(user.id)} 
                      className="p-2 text-red-500 hover:bg-red-50 hover:text-red-700 rounded-lg transition-colors"
                      title="Delete User"
                    >
                      <Trash2 size={18} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default UserList;